import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/store/Store";
import { getActiveCorporatePatinetList } from "../../../redux/effects/ApiCall";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import MWExceptionList from "../../../component/MWExceptionList";
import AdminLoader from "../../AdminLoader";
import { t } from "i18next";

export default function ActivePatientList(id: any) {
  let packageId = id.packageId;

  const history = useHistory();
  const dispatch = useDispatch();

  const loadingMarkup = <AdminLoader />;

  const gotoDetails = (profileId: any) => {
    history.push(`/inactivepatientpaymentdetails/${packageId}/${profileId}`);
  };

  useEffect(() => {
    dispatch(getActiveCorporatePatinetList(packageId));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // call Store
  const activeCorporatePatientList = useSelector(
    (state: AppState) => state.activeCorporatePatientValue
  );
  const activeCorporatePatientListValues =
    activeCorporatePatientList.activeCorporatePatientListValue;
  const activeCorporatePatientTeamCount =
    activeCorporatePatientList.totalNoOfPatientTeam;

  let inActiveCorporatePatientListConfig: any = [];
  for (var i = 0; i < activeCorporatePatientListValues.length; i++) {
    let profileId =
      activeCorporatePatientListValues[i].profileId === null
        ? ""
        : activeCorporatePatientListValues[i].profileId;
    let firstname =
      activeCorporatePatientListValues[i].firstname === null ||
      activeCorporatePatientListValues[i].firstname === ""
        ? ""
        : activeCorporatePatientListValues[i].firstname;
    let lastname =
      activeCorporatePatientListValues[i].lastname === null ||
      activeCorporatePatientListValues[i].lastname === ""
        ? ""
        : activeCorporatePatientListValues[i].lastname;
    let email =
      activeCorporatePatientListValues[i].email === null ||
      activeCorporatePatientListValues[i].email === ""
        ? ""
        : activeCorporatePatientListValues[i].email;
    inActiveCorporatePatientListConfig.push([
      <Button
        variant="outlined"
        onClick={() => gotoDetails(profileId)}
        startIcon={<PreviewIcon />}
      >
        {t("common.view", { ns: ["home"] })}
      </Button>,
      firstname,
      lastname,
      email,
    ]);
  }
  const corporateInactivePatientListTableValue: any[] =
    inActiveCorporatePatientListConfig;

  const actualPageMarkup = (
    <Box sx={{ pt: 4 }}>
      <Card sx={{ backgroundColor: "#142329" }}>
        <Grid>
          <CardHeader
            title={t("common.patientTeamDetail", { ns: ["home"] })}
          ></CardHeader>
          <CardContent>
            <Box pl={3}>
              {t("corporatepackage.numberof", { ns: ["home"] })}:{" "}
              {activeCorporatePatientTeamCount}
              {corporateInactivePatientListTableValue &&
              corporateInactivePatientListTableValue.length ? (
                <TableContainer>
                  <Table size="small" aria-label="a dense table">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          {t("corporatepackage.viewdetails", { ns: ["home"] })}
                        </TableCell>
                        <TableCell>
                          {t("patientteamlistpage.firstname", { ns: ["home"] })}
                        </TableCell>
                        <TableCell>
                          {t("patientteamlistpage.lastname", { ns: ["home"] })}
                        </TableCell>
                        <TableCell>
                          {t("patientteamlistpage.email", { ns: ["home"] })}
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {corporateInactivePatientListTableValue.map(
                        (row: any) => (
                          <TableRow
                            key={row.Email}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell align="left">{row[0]}</TableCell>
                            <TableCell align="left">{row[1]}</TableCell>
                            <TableCell align="left">{row[2]}</TableCell>
                            <TableCell align="left">{row[3]}</TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography>
                  <MWExceptionList />
                </Typography>
              )}
            </Box>
          </CardContent>
        </Grid>
      </Card>
    </Box>
  );
  return (
    <Container maxWidth="xl">
      {activeCorporatePatientList === undefined ? "" : loadingMarkup}
      {actualPageMarkup}
    </Container>
  );
}
